/* eslint-disable react/prop-types */
import React from 'react';
import './style.css';
import { ModalTemplateProps } from '../../../interfaces/Modals';


const ModalTemplate: React.FC<ModalTemplateProps> = ({
  headerMessage,
  modalImg,
  intermediateMessage,
  finalMessage,
}) => {
  return (
    <div className='CustomModal'>
      <div className='custom-modal-bodyguard custom-modal-bodyguard-light '>
        <div className='custom-art-modal wait-simple'>
          <div className='custom-label'>
            <header className='custom-modal-header'>
              <p
                style={{
                  margin: '0px 0px 0px 35px',
                  fontSize: '16px',
                  fontFamily: 'Arial',
                  fontStyle: 'Regular',
                }}
              >
                {headerMessage}
              </p>
            </header>
            <div className='custom-modal-body'>
              <label className='custom-modal-body-label'>
                <img width='50px' height='50px' src={modalImg} alt="Modal" />
                <p
                  style={{
                    margin: '10px',
                    fontSize: '20px',
                    fontWeight: 500,
                    textAlign: 'center',
                    padding: '0xp 10px',
                    color: 'rgba(48, 61, 73, 1)',
                    fontFamily: 'Arial',
                    fontStyle: 'Regular',
                  }}
                >
                  {intermediateMessage}
                </p>
                <p
                  style={{
                    margin: '10px',
                    fontWeight: 500,
                    textAlign: 'center',
                    padding: '0xp 10px',
                    color: 'rgba(119, 119, 119, 1)',
                    fontFamily: 'Lato',
                    fontStyle: 'Regular',
                  }}
                >
                  {finalMessage}
                </p>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalTemplate;